export const metaverse = {
  matter: '0xeE8B517bCB8994B25Ec666904e98349B15fFE441',
  antimatter: '0x343700c691c91F24Eb03B8f203e9B56C54475E06',
  energy: '0xa740b973d7f042Af9eE86fb9ec2228683C108Bc1',
  matterSupply: 100000000,
  matterAirdrop: 1000000,
  antimatterSupply: 100000000,
  antimatterAirdrop: 500000,
  time: 1672354800,
  node: 'https://goerli.infura.io/v3/86ff3f5f8da948ec8ed4bb05bb5cd3d5',
  owner: '0x605AB73671250761B9E81FB2FB99BC7ed5a50547',
  decimals: 18
}